import {TYPES} from '../Actions/authAction';
import * as moment from 'moment';

const authReducer = (state = {}, action) => {
    switch (action.type) {
        case TYPES.LOGIN_SUCCESS:
        case TYPES.LOGOUT_SUCCESS:
            return {
                ...state,
                loggedIn: action.loggedIn
            };
        case TYPES.ROBOT_LOGIN_SUCCESS:
            return {
                ...state,
                robotLoggedIn: {
                    value: action.robotLoggedIn,
                    updatedAt: moment()
                }
            };
        case TYPES.TD_LOGIN_SUCCESS:
            return {
                ...state,
                tdLoggedIn: {
                    value: action.tdLoggedIn,
                    updatedAt: moment()
                }
            };
		case TYPES.FORGOT_PASSWORD_EMAIL_SUCCESS:
			return {
				...state,
				forgotPasswordEmailStatus: action.forgotPasswordEmailStatus
			};
        case TYPES.UPDATE_USER_SUCCESS:
            return {
                ...state,
                updateUserStatus: action.updateUserStatus
            };
		case TYPES.RESET_PASSWORD_SUCCESS:
			return {
				...state,
				resetPasswordStatus: action.resetPasswordStatus
			};
        case TYPES.VALIDATE_IDENTITY_SUCCESS:
            return {
                ...state,
                validationStatus: action.validationStatus
            };
        case TYPES.RESET_SECRET_SUCCESS:
            return {
                ...state,
                secretDetails: action.secretDetails
            };
        default:
            return state;
    }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/ReduxRequests/Reducer/authReducer.ts